import React from 'react';
import classNames from 'classnames';

import propTypes from 'prop-types';
import CartLineItem from '../../containers/CartLineItem';
import { TranslatedMessage } from 'common/components/Intl';
import PriceSpan from 'common/components/formatters/PriceSpan';

export default class LineItems extends React.Component {
  static propTypes = {
    lineItemsSubscribable: propTypes.array.isRequired,
    lineItemsRegular: propTypes.array.isRequired,
    isMembershipOrder: propTypes.bool.isRequired,
    subscribableCostOrig: propTypes.number.isRequired,
    subscribableCostNew: propTypes.number.isRequired,
    subscribableQuantity: propTypes.number.isRequired,
  };

  renderlineItem = lineItem => {
    return <CartLineItem key={lineItem.id} item={lineItem} />;
  };

  render() {
    const {
      lineItemsSubscribable,
      lineItemsRegular,
      isMembershipOrder,
      subscribableCostOrig,
      subscribableCostNew,
      subscribableQuantity,
      subscribableVariantDiscountRate,
    } = this.props;

    const shouldShowMonthlySavingsBanner =
      isMembershipOrder &&
      !!subscribableQuantity &&
      subscribableVariantDiscountRate > 0;

    return (
      <div className="CartSidebar__line-items">
        {lineItemsSubscribable.map(l => this.renderlineItem(l))}
        {shouldShowMonthlySavingsBanner && (
          <div className="MonthlySavingsBanner">
            <div
              className={classNames(
                'text--body',
                'MonthlySavingsBanner__title'
              )}
            >
              <TranslatedMessage id={'cart.line_items.monthly'} />
            </div>

            <PriceSpan
              className={classNames(
                'text--body--small',
                'MonthlySavingsBanner__price--orig'
              )}
              amount={subscribableCostOrig}
            />

            <PriceSpan
              className={classNames(
                'text--body',
                'MonthlySavingsBanner__price--new'
              )}
              amount={subscribableCostNew}
            />
          </div>
        )}
        {lineItemsRegular.map(l => this.renderlineItem(l))}
      </div>
    );
  }
}
